import { Medium } from "@bkry/bowline-components/Medium";
import { getMilestoneAttributes } from "@bkry/bowline-redux/milestones";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";

const RoadmapMilestone = (props, context) => {
  const { milestoneId, index } = props;
  const milestoneData = useSelector((state) =>
    getMilestoneAttributes(state, milestoneId)
  );

  if (!milestoneData) return null;

  return (
    <div key={index} className="roadmap__step">
      <span className="roadmap__step__dot">
        <span className="sr-only">{index}</span>
      </span>
      <div
        className={
          index % 2 === 0 ? "message message--left" : "message message--right"
        }
      >
        <Row>
          {milestoneData.image && (
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div>
                <Medium
                  mediumData={milestoneData.image}
                  altTitle={milestoneData.title}
                />
              </div>
            </Col>
          )}
          <Col>
            <p className="fw-light h3">{milestoneData?.title}</p>
            <p className="fw-light h6">{milestoneData?.subtitle}</p>
            {milestoneData?.description && (
              <div
                className="text-wrap"
                dangerouslySetInnerHTML={{
                  __html: milestoneData?.description.replace(
                    /href="http/g,
                    ` target='_blank' rel='noopener noreferrer' href="http`
                  ),
                }}
              />
            )}
            {milestoneData?.anchorTarget && (
              <p
                onClick={() => {
                  const element = document.getElementById(
                    `${milestoneData?.anchorTarget}`
                  );
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="small fw-lighter mb-0"
              >
                <span className="pointer-url">{context.t("here")}</span>
              </p>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
RoadmapMilestone.contextTypes = {
  t: PropTypes.func,
};

RoadmapMilestone.propTypes = {
  milestoneId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

RoadmapMilestone.defaultProps = {};

export default RoadmapMilestone;
